import { Card } from "@mui/material";

import styled from "styled-components";

export const SourcePopoverAnchor = styled.span`
    display: block;
    height: 0;
`;

export const SourcePopoverContainer = styled(Card)`
    width: 100%;
    max-height: 400px !important;
    overflow-y: auto !important;
`;
